export const TM_PAGE_DEFS = [
  { key: "drivers", label: "Drivers", path: "/drivers" },
  { key: "certificates", label: "Certificates", path: "/certificates" },
  { key: "fleet", label: "Fleet & Filings", path: "/fleet" },
  { key: "randoms", label: "Random Selections", path: "/randoms" },
  { key: "chat", label: "Messages", path: "/chat" },
  { key: "applicants", label: "Applicants", path: "/applicants" },
];
export const TM_DEFAULT_PAGES = ["drivers", "fleet", "randoms", "chat"];

export function tmPages(user) {
  return Array.isArray(user?.pages) ? user.pages : TM_DEFAULT_PAGES;
}

export function canManageApplicants(user) {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (user.role === "terminal_manager") return tmPages(user).includes("applicants");
  return !user.shared || !!user.can_manage_applicants;
}

export function tmAllowedPaths(user) {
  return ["/dashboard", "/profile", ...TM_PAGE_DEFS.filter((p) => tmPages(user).includes(p.key)).map((p) => p.path)];
}
